import { render, staticRenderFns } from "./sport.vue?vue&type=template&id=4b96350c&scoped=true"
import script from "./sport.vue?vue&type=script&lang=js"
export * from "./sport.vue?vue&type=script&lang=js"
import style0 from "./sport.vue?vue&type=style&index=0&id=4b96350c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96350c",
  null
  
)

export default component.exports